import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const emailTemplateListService = (
  params: Types.EmailTemplateListRequest
) =>
  RestAPIClient.call<Types.EmailTemplateListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const emailTemplateCreateService = (
  params: Types.EmailTemplateCreateRequest
) =>
  RestAPIClient.call<Types.EmailTemplate>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const emailTemplateUpdateService = (
  params: Types.EmailTemplateUpdateRequest
) =>
  RestAPIClient.call<Types.EmailTemplate>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const emailTemplateDetailService = (id: string) =>
  RestAPIClient.call<Types.EmailTemplate>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
